
import React, { useRef, DragEvent } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface ImportDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onFileSelect: () => void;
  onDialogDrop: (e: DragEvent<HTMLDivElement>) => void;
  handleDialogDragEnter: (e: DragEvent<HTMLDivElement>) => void;
  handleDialogDragOver: (e: DragEvent<HTMLDivElement>) => void;
  handleDialogDragLeave: (e: DragEvent<HTMLDivElement>) => void;
  isDialogDragging: boolean;
  fileInputRef: React.RefObject<HTMLInputElement>;
}

const ImportDialog = ({
  isOpen,
  onOpenChange,
  onFileSelect,
  onDialogDrop,
  handleDialogDragEnter,
  handleDialogDragOver,
  handleDialogDragLeave,
  isDialogDragging,
  fileInputRef
}: ImportDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 text-white border-slate-700">
        <DialogHeader>
          <DialogTitle>Import Excel Data</DialogTitle>
          <DialogDescription className="text-slate-400">
            Upload an Excel file (.xlsx or .xls) with your leaderboard data.
          </DialogDescription>
        </DialogHeader>
        
        <div 
          className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${isDialogDragging ? 'border-blue-500 bg-slate-700/50' : 'border-slate-600 hover:border-blue-400 hover:bg-slate-700/30'}`} 
          onClick={onFileSelect} 
          onDragEnter={handleDialogDragEnter} 
          onDragOver={handleDialogDragOver} 
          onDragLeave={handleDialogDragLeave} 
          onDrop={onDialogDrop}
        >
          <input ref={fileInputRef} type="file" accept=".xlsx, .xls" className="hidden" />
          <Download className="h-10 w-10 mx-auto mb-3 text-slate-400" />
          <p className="text-slate-300 font-medium">
            Click to browse or drag and drop
          </p>
          <p className="text-slate-400 text-sm mt-1">
            Supports Excel files (.xlsx, .xls)
          </p>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-600 text-black bg-white">
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ImportDialog;
